<template>
	<div class='container'>
		<hr
			class="divider"
			:style="cssVars"
		/>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		thickness: {
			default: '4px',
		},
		topMargin: {
			default: '80px',
		},
		bottomMargin: {
			default: '80px',
		},
		colour: {
			default: '#212121',
		},
		hide_on_mobile: {
			default: 'No',
		},
		hide_on_desktop: {
			default: 'No',
		},
		size: {
			default: '1 / span 12',
		},
	},

	computed: {
		cssVars() {
			return {
				'--thickness': this.thickness ? this.thickness : '4px',
				'--top-margin': this.topMargin ? this.topMargin : '80px',
				'--bottom-margin': this.bottomMargin ? this.bottomMargin : '80px',
				'--colour': this.colour ? this.colour : 'transparent',
				'--size': this.size ? this.size : '1 / span 12',
			};
		},
	},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.divider {
	border: 0;
	border-top: var(--thickness) solid var(--colour);
	border-radius: 0;
	max-width: $max-width;
	margin: var(--top-margin) auto var(--bottom-margin) !important;
	position: relative;
	z-index: 15;
	overflow: hidden;
	grid-column: var(--size);
	width: 100%;

	/* @media (max-width: $max-width) {
		width: calc(100% - calc(60px * 2));
	} */

	@media (max-width: $tablet) {
		/* width: calc(100% - calc(20px * 2)); */
		margin: calc(40px / 2) auto;

		.project_body & {
			width: 100%;
			margin: calc(40px / 2) 0;
		}
	}

	@media (max-width: 1024px) {
		grid-column: span 4;

		.project_body & {
			width: 100%;
			margin: calc(40px / 2) 0;
		}
	}

	@media (max-width: $mobile) {
		/* width: calc(100% - calc(20px * 2)); */
		margin: calc(40px / 2) auto;

		.project_body & {
			width: 100%;
			margin: calc(40px / 2) 0;
		}
	}

	.project_body & {
		width: calc(100% - 16px);
		margin: var(--top-margin) 0 var(--bottom-margin);
	}

	.single-event & {
		grid-column: 2 / span 8;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PageDivider.vue